import { Reveal, SectionHead } from "./Reveal";
import { WaButton } from "./WaButton";

const STEPS = [
  { n: "01", title: "Você entra em contato", desc: "Envie uma mensagem pelo WhatsApp, informe sua localização e explique o serviço que precisa." },
  { n: "02", title: "Entendemos sua necessidade", desc: "Nossa equipe analisa as informações e verifica a possibilidade de atendimento conforme a necessidade apresentada." },
  { n: "03", title: "Alinhamos o orçamento", desc: "O escopo, os materiais necessários, os valores e as condições de atendimento são esclarecidos antes da contratação." },
  { n: "04", title: "Realizamos o serviço", desc: "Após a aprovação do orçamento, o serviço é executado conforme o escopo combinado, com as condições de garantia aplicáveis." },
];

export default function ComoFunciona() {
  return (
    <section id="como-funciona" className="bg-white py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead index="04" label="Como funciona" title="Como funciona o atendimento" />

        <div data-testid="hidropro-how-it-works-steps" className="relative mt-12 lg:mt-16">
          <div className="dash-flow-vertical absolute bottom-8 left-[27px] top-10 w-px sm:hidden" />
          <div className="dash-flow absolute left-[9%] right-[9%] top-[27px] hidden h-px lg:block" />
          <div className="grid grid-cols-1 gap-8 sm:gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            {STEPS.map((step, i) => (
              <Reveal key={step.n} delay={i * 0.12}>
                <div className="relative flex items-start gap-5 sm:flex-col lg:items-center lg:gap-5 lg:text-center">
                  <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-[#0A5C8C] bg-paper font-mono text-sm font-bold text-[#0A5C8C] shadow-[0_0_0_6px_rgba(10,92,140,0.08)]">
                    {step.n}
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-bold tracking-tight text-[#1A1A1A]">{step.title}</h3>
                    <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600 lg:mx-auto">{step.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 flex justify-center lg:mt-14">
            <WaButton big testId="hidropro-steps-whatsapp-button" label="Solicitar atendimento pelo WhatsApp" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
